import { memo } from 'react'
import type { MediaFile } from '../../lib/mediaBrowserApi.js'
import { formatFileSize } from '../../lib/utils.js'

// ─── Ligne de fichier / dossier du navigateur de médias ───────────────────────

const EXT_TONES: Record<string, string> = {
  '.mxf': 'mxf', '.mp4': 'mp4', '.mov': 'mov',
  '.ts': 'transport', '.mts': 'transport', '.avi': 'neutral',
  dir: 'directory',
}

interface MediaFileRowProps {
  file:           MediaFile
  selected:       boolean
  onClick:        () => void
  onDoubleClick:  () => void
  /** Affiche le dossier parent — utile en mode recherche globale. */
  showPath?:      boolean
  title?:         string
}

export const MediaFileRow = memo(function MediaFileRow({
  file, selected, onClick, onDoubleClick, showPath = false, title,
}: MediaFileRowProps) {
  const isDir = file.type === 'directory'
  const extTone = isDir ? EXT_TONES.dir : (EXT_TONES[file.ext || ''] ?? 'neutral')
  const sizeLabel = isDir ? '' : formatFileSize(file.size)

  // Chemin relatif sans le nom du fichier
  const folderPath = file.relativePath.includes('/')
    ? file.relativePath.split('/').slice(0, -1).join('/')
    : ''

  return (
    <button
      type="button"
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      aria-pressed={selected}
      title={title}
      className={selected ? 'catalog-media-file is-selected' : 'catalog-media-file'}
    >
      {/* Badge extension ou dossier */}
      <span className={`catalog-media-file__badge catalog-media-file__badge--${extTone}`}>
        {isDir ? (
          <svg aria-hidden="true" width="12" height="12" viewBox="0 0 16 16" fill="currentColor">
            <path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.437 0 .852.19 1.133.521L7.948 4H13.5A1.5 1.5 0 0 1 15 5.5v7A1.5 1.5 0 0 1 13.5 14H2.5A1.5 1.5 0 0 1 1 12.5v-9z"/>
          </svg>
        ) : (
          (file.ext || '').replace('.', '').toUpperCase()
        )}
      </span>

      {/* Nom */}
      <span className="catalog-media-file__copy">
        <span className="catalog-media-file__name">
          {file.name}{isDir ? '/' : ''}
        </span>
        {showPath && folderPath && (
          <span className="catalog-media-file__path">
            {folderPath}/
          </span>
        )}
      </span>

      {/* Taille */}
      <span className="catalog-media-file__size">
        {sizeLabel}
      </span>
    </button>
  )
})
